import './components/calculators/format';
import './components/calculators/input';

// =====================================================================
//  SOCSO / EIS (PERKESO) — interactivity layer
//  Static markup lives in page-calculator-socso.php.
//  Contribution table comes from the page as DB-editable JSON (Calc.data.socso).
// =====================================================================
(function () {
  const fmt = Calc.format;

  const DATA = (window.Calc && Calc.data && Calc.data.socso) ? Calc.data.socso : { ceiling: 6000, bands: [] };
  const BANDS = Array.isArray(DATA.bands) ? DATA.bands : [];
  const CEILING = DATA.ceiling || 6000;
  const cap = (t) => (t === null || t === undefined) ? Infinity : t;

  const REF_WAGES = [1500, 2000, 3000, 4000, 5000, 6000, 7000];

  const state = {
    wage: 3000,
    cat: 'under60',   // 'under60' (Cat 1) | 'over60' (Cat 2)
    l24: false,       // LINDUNG 24 Jam (SKBBK) — opt-in (employees may opt out)
    activeTab: 'breakdown',
  };

  const setText = (id, val) => { const el = document.getElementById(id); if (el) el.textContent = val; };
  const toggleAll = (sel, hide) => document.querySelectorAll(sel).forEach(el => el.classList.toggle('d-none', hide));
  const syncInput = (id, val) => Calc.input.syncValue(id, val);

  function findBand(wage) {
    for (const b of BANDS) {
      if (wage <= cap(b.to)) return b;
    }
    return BANDS.length ? BANDS[BANDS.length - 1] : null;
  }

  // Returns the per-scheme contributions for a wage + category.
  // LINDUNG 24 Jam (SKBBK) is employee-only and has no age limit, so it is a
  // purely additive employee line in BOTH categories — the employer side and
  // every pre-existing figure are untouched by it.
  function contributions(wage, cat) {
    const b = findBand(wage);
    if (!b) return { band: null, socsoEE: 0, socsoER: 0, eisEE: 0, eisER: 0, l24EE: 0 };
    const l24EE = state.l24 ? (b.l24 || 0) : 0;
    if (cat === 'over60') {
      // Category 2: Employment Injury only (employer), no employee share, no EIS.
      return { band: b, socsoEE: 0, socsoER: b.c2er, eisEE: 0, eisER: 0, l24EE };
    }
    // Category 1: SOCSO employee + employer, plus EIS (employee = employer).
    return { band: b, socsoEE: b.c1ee, socsoER: b.c1er, eisEE: b.eis, eisER: b.eis, l24EE };
  }

  function bandLabel(b) {
    if (!b) return '—';
    if (b.from === 0) return `≤ RM ${fmt.number(b.to, 2)}`;
    if (b.to === null || b.to === undefined) return `> RM ${fmt.number(b.from, 2)}`;
    return `RM ${fmt.number(b.from + 0.01, 2)} – ${fmt.number(b.to, 2)}`;
  }

  function updateStatBand() {
    const c = contributions(state.wage, state.cat);
    setText('socso-stat-employee', fmt.money(c.socsoEE + c.eisEE + c.l24EE, 2));
    setText('socso-stat-employer', fmt.money(c.socsoER + c.eisER, 2));
    // LINDUNG 24 Jam is an Act 4 contribution, so PERKESO counts it inside the
    // Akta 4 total — keeping it here also makes SOCSO + EIS equal the grand total.
    setText('socso-stat-socso',    fmt.money(c.socsoEE + c.socsoER + c.l24EE, 2));
    setText('socso-stat-eis',      fmt.money(c.eisEE + c.eisER, 2));
  }

  function updateBreakdown() {
    const c = contributions(state.wage, state.cat);
    const cw = Math.min(state.wage, CEILING);
    setText('socso-r-wage',     fmt.money(cw, 2));
    setText('socso-r-band',     bandLabel(c.band));
    setText('socso-r-socso-ee', fmt.money(c.socsoEE, 2));
    setText('socso-r-socso-er', fmt.money(c.socsoER, 2));
    setText('socso-r-eis-ee',   fmt.money(c.eisEE, 2));
    setText('socso-r-eis-er',   fmt.money(c.eisER, 2));
    setText('socso-r-l24-ee',   fmt.money(c.l24EE, 2));

    // Only show rows for schemes that actually apply: Category 2 has no employee
    // SOCSO share and no EIS at all, and PERKESO likewise omits its Akta 800
    // table for Category 2 rather than printing zeros.
    const hideRow = (id, hide) => {
      const el = document.getElementById(id);
      if (el) el.classList.toggle('d-none', hide);
    };
    const isCat2 = state.cat === 'over60';
    hideRow('socso-r-socso-ee-row', isCat2);
    hideRow('socso-r-eis-ee-row',   isCat2);
    hideRow('socso-r-eis-er-row',   isCat2);
    hideRow('socso-r-l24-row',      !state.l24);
    setText('socso-r-total-ee', fmt.money(c.socsoEE + c.eisEE + c.l24EE, 2));
    setText('socso-r-total-er', fmt.money(c.socsoER + c.eisER, 2));
    setText('socso-r-grand',    fmt.money(c.socsoEE + c.socsoER + c.eisEE + c.eisER + c.l24EE, 2));
  }

  function updateReferenceGrid() {
    const tbody = document.getElementById('socso-grid-tbody');
    if (!tbody) return;
    tbody.innerHTML = REF_WAGES.map(w => {
      const c = contributions(w, state.cat);
      const ee = c.socsoEE + c.eisEE + c.l24EE;
      const er = c.socsoER + c.eisER;
      const hi = w === state.wage;
      return `<tr class="${hi ? 'highlight' : ''}"><th>RM ${w.toLocaleString()}</th>` +
             `<td>${fmt.number(ee, 2)}</td><td>${fmt.number(er, 2)}</td><td>${fmt.number(ee + er, 2)}</td></tr>`;
    }).join('');
  }

  function refresh() {
    syncInput('socso-wage-input', state.wage);

    const isOver = state.cat === 'over60';
    toggleAll('.socso-cat-hint-under60', isOver);
    toggleAll('.socso-cat-hint-over60', !isOver);
    document.querySelectorAll('#socso-cat-tabs button').forEach(btn => {
      const active = btn.dataset.cat === state.cat;
      btn.classList.toggle('btn-primary', active);
      btn.classList.toggle('btn-outline-primary', !active);
    });
    document.querySelectorAll('#socso-l24-tabs button').forEach(btn => {
      const active = (btn.dataset.l24 === 'on') === state.l24;
      btn.classList.toggle('btn-primary', active);
      btn.classList.toggle('btn-outline-primary', !active);
    });

    updateStatBand();
    if (state.activeTab === 'breakdown') updateBreakdown();
    else updateReferenceGrid();
  }

  function activateTab(tabId) {
    state.activeTab = tabId;
    document.querySelectorAll('#socso-tabs .btn-tab').forEach(btn => {
      btn.classList.toggle('active', btn.dataset.tab === tabId);
    });
    document.querySelectorAll('.tab-panel').forEach(panel => {
      panel.classList.toggle('d-none', panel.id !== `socso-tab-${tabId}`);
    });
    if (tabId === 'breakdown') updateBreakdown();
    else updateReferenceGrid();
  }

  function bindEvents() {
    ['input', 'change'].forEach(evt => document.addEventListener(evt, (e) => {
      if (e.target.id === 'socso-wage-input') {
        state.wage = Calc.input.getValue(e.target) || 0;
        refresh();
      }
    }));

    document.querySelectorAll('#socso-cat-tabs button').forEach(btn =>
      btn.addEventListener('click', () => { state.cat = btn.dataset.cat; refresh(); }));

    document.querySelectorAll('#socso-l24-tabs button').forEach(btn =>
      btn.addEventListener('click', () => { state.l24 = (btn.dataset.l24 === 'on'); refresh(); }));

    document.querySelectorAll('#socso-tabs .btn-tab').forEach(btn =>
      btn.addEventListener('click', () => activateTab(btn.dataset.tab)));
  }

  document.addEventListener('DOMContentLoaded', () => {
    bindEvents();
    refresh();
  });
})();
